import { useState } from 'react';

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

/**
 * @hook useMultiSelectFilter
 * @params {array} options
 * @params {array} value
 */
const useMultiSelectFilter = (params = {}) => {
    const [value, setValue] = useState(params.value || []);
    const options = params.options || [];

    const addValue = (key) => {
        setValue([...value, key]);
    };

    const removeValue = (key) => {
        let values = [...value];
        const index = values.indexOf(key);
        if (index > -1) { values.splice(index, 1); }
        setValue(values);
    };

    const toggleValue = (key) => {
        if (value.indexOf(key) === -1) {
            addValue(key);
        } else {
            removeValue(key);
        }
    };

    return {
        addValue,
        options,
        removeValue,
        setValue,
        toggleValue,
        value
    };
};


/**
 * @hook useSingleSelectFilter
 * @params {array} options
 * @params {string} value
 */
const useSingleSelectFilter = (params = {}) => {
    const [value, setValue] = useState(params.value || '');
    const options = params.options || [];

    return {
        options,
        value,
        setValue
    };
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export {
    useMultiSelectFilter,
    useSingleSelectFilter
};
